$( document ).ready(function() {
    console.log('Hello JS')


    $('.main-carousel').flickity({
      // options
      cellAlign: 'left',
      contain: true
    });

});


